import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`;

const readNutrients = async (
  offset,
  pageSize,
  searchType,
  searchText,
  orderType,
  orderBy,
  pageType,
) => {
  const { data } = await axios.get(
    `${baseUrl}/nutrients/list?offset=${offset}&pageSize=${pageSize}&searchType=${searchType}&searchText=${searchText}&orderType=${orderType}&orderBy=${orderBy}&pageType=${pageType}`,
  );
  return data;
};

const removeNutrients = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/nutrients/${id}`);
  return data;
};

const totalCntList = async (searchText, searchType, pageType) => {
  const { data } = await axios.get(
    `${baseUrl}/nutrients/totalCntList?searchText=${searchText}&searchType=${searchType}&pageType=${pageType}`,
  );
  return data;
};

const editNutrients = async (editNutrients) => {
  const { data } = await axios.put(`${baseUrl}/nutrients`, editNutrients);
  return data;
};

const createNutrients = async (createNutrients) => {
  const { data } = await axios.post(`${baseUrl}/nutrients`, createNutrients);
  return data;
};

/**
 * readNutrientsNutrition (2022.09.29) - ksb
 * @param param
 * @returns {Promise<never>}
 */
const readNutrientsNutrition = async (nutrients_id) => {
  const { data } = await axios.get(
    `${baseUrl}/nutrients/admin?nutrients_id=${nutrients_id}`,
  );
  return data;
};

const createExcelNutrients = (param) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrl}/nutrients/excel`, param)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  });
};

const readNutrientSearchOption = async (nutrients_id) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_BACKEND_HOST}/nutrientsKpi/searchOption?nutrients_id=${nutrients_id}`,
  );
  return data;
};

const nutrientsApi = {
  readNutrients,
  removeNutrients,
  totalCntList,
  editNutrients,
  createNutrients,
  readNutrientsNutrition,
  createExcelNutrients,
  readNutrientSearchOption,
};

export default nutrientsApi;
